// extracted by mini-css-extract-plugin
module.exports = {"salaryInfo":"styles_salaryInfo__2J9Iz","salaryInfoText":"styles_salaryInfoText__13kB_","amount":"styles_amount__1rpM8"};